import React, { useEffect } from 'react'
import GifLoader from 'three-gif-loader';
import { MeshBasicMaterial, Mesh, PlaneBufferGeometry} from 'three'
import { gifMap } from './GifConfig';
import { ThreeCacheManager } from 'web-store-modules/packages/three-cache-manager';

let planes = []

const gifLoader = new GifLoader();

export default ({ roomId, threeJSWorldContext }) => {


    const getTexture = (url) => {
        const cachedTexture = ThreeCacheManager.get(url);
        if (cachedTexture) {
            return cachedTexture;
        }
        const texture = gifLoader.load(url, null, null, null);
        ThreeCacheManager.add(url, texture);
        return texture;
    }


    const getGifMesh = (url, position, rotation, scale) => {
        const texture = getTexture(url);
        const material = new MeshBasicMaterial({
            map: texture,
            transparent: true
        });
        const geometry = new PlaneBufferGeometry('200', '100');
        material.needsUpdate = true;
        const mesh = new Mesh(geometry, material);

        mesh.position.set(position[0], position[1], position[2]);
        mesh.rotation.set(rotation[0], rotation[1], rotation[2]);
        mesh.scale.set(scale[0], scale[1], scale[2]);

        mesh.visible = true;
        return mesh
    }

    const addGifToScene = (url, position, rotation, scale) => {
        return new Promise((resolve, reject) => {
            const { scene } = threeJSWorldContext;
            const plane = getGifMesh(url, position, rotation, scale);
            scene.add(plane)
            planes.push(plane)
            resolve()
        });

    }

    useEffect(() => {
        if (!threeJSWorldContext)
            return

        const { scene, addToRenderLoop, removeFromRenderLoop } = threeJSWorldContext

        let renderUUID = null;
        for (const plane of planes) {
            scene.remove(plane)
        }
        planes = []

        const sceneGifs = gifMap[roomId];
        Promise.all(sceneGifs.map((config) => addGifToScene(...config)))
        .then(
            renderUUID = addToRenderLoop()
        );

        return function () {
            for (const plane of planes) {
                scene.remove(plane)
            }
            removeFromRenderLoop(renderUUID)
        }
    }, [roomId, threeJSWorldContext])

    return null;
}
